// extracted by mini-css-extract-plugin
export var cardContainer = "_p8-0";
export var cardHeader = "_p8-2";
export var collapsedState = "_p8-3";
export var dragHandle = "_p8-5";
export var dragHandleIcon = "_p8-6";
export var dragging = "_p8-1";
export var titleArea = "_p8-4";